// eslint-disable-next-line no-restricted-imports
import { Menu as MenuBase } from "@base-ui/react/menu";
import classNames from "classnames";
import { CheckIcon } from "@icons";
import {
    MenuItemContent,
    menuItemClassName,
    renderRowWithTooltip,
} from "./MenuItemContent";
import type { MenuRadioGroupProps, MenuRadioItemProps } from "./Menu.types";
import itemStyles from "./MenuItem.module.scss";
import popupStyles from "./MenuPopup.module.scss";

/** One choice out of its `Menu.RadioItem` rows; label it with `Menu.GroupLabel`. */
export const MenuRadioGroup = ({
    value,
    onValueChange,
    children,
    className,
}: MenuRadioGroupProps) => (
    <MenuBase.RadioGroup
        value={value}
        onValueChange={onValueChange}
        className={classNames(popupStyles.group, className)}
    >
        {children}
    </MenuBase.RadioGroup>
);

/**
 * A `menuitemradio` row of a `Menu.RadioGroup`: selects its `value` and
 * closes the menu. The selected row shows a trailing check; the others
 * keep its slot empty so labels line up.
 */
export const MenuRadioItem = ({
    value,
    children,
    leading,
    disabled = false,
    disabledReason,
    closeOnClick = true,
    className,
    ref,
    "data-forced-state": forcedState,
}: MenuRadioItemProps) => (
    <MenuBase.RadioItem
        ref={ref}
        value={value}
        disabled={disabled}
        closeOnClick={closeOnClick}
        className={menuItemClassName({
            hasDescription: false,
            isDestructive: false,
            className,
        })}
        data-forced-state={forcedState}
        render={renderRowWithTooltip({
            isDisabled: disabled,
            disabledReason,
        })}
    >
        <MenuItemContent
            leading={leading}
            trailing={
                <span className={itemStyles.itemCheckSlot} aria-hidden>
                    <MenuBase.RadioItemIndicator
                        className={itemStyles.itemCheck}
                    >
                        <CheckIcon />
                    </MenuBase.RadioItemIndicator>
                </span>
            }
        >
            {children}
        </MenuItemContent>
    </MenuBase.RadioItem>
);
